<template>
  <div class="sort">
    <DropdownComponent v-if="items.length" :close-on-click="false" class="sort__sort">
      <ButtonComponent class="sort__trigger">
        <template #label>
          <span class="sort__label">
            <span> {{ $t('sortBy') }}: </span>
            <span class="sort__value">
              <template>
                <span>{{ sortLabel || $t('select') }}</span>
                <FontAwesomeIcon class="ml-2" :icon="['fal', 'angle-down']" size="lg" />
              </template>
            </span>
          </span>
        </template>
      </ButtonComponent>

      <template #dropdown>
        <template v-for="item in items">
          <ButtonComponent :key="item.key" @click="updateSort(item, (value[item.key] || -1) * -1)">
            <template #label>
              <span class="sort__item-label">
                <span>{{ item.label }}</span>
                <FontAwesomeIcon
                  v-if="item.key in value"
                  :icon="['fas', value[item.key] === -1 ? 'caret-up' : 'caret-down']"
                  size="lg"
                />
              </span>
            </template>
          </ButtonComponent>
        </template>
      </template>
    </DropdownComponent>
  </div>
</template>

<script>
import { path } from 'ramda'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { DropdownComponent } from 'vue-elder-dropdown'

const SortWatcher = funcKey => {
  return {
    sort: {
      handler(val) {
        let [key] = Object.keys(val)
        let match = this.sortableBy.find(e => e.key === key)
        if (match && match.virtual) return

        return this[funcKey]()
      },
      deep: true,
    },
  }
}

const Sort = function (items, sortBy, direction = 1, match = {}) {
  return items.sort((a, b) => {
    let [aValue, bValue] = [path(sortBy.split('.'), a), path(sortBy.split('.'), b)]

    const getType = value => {
      if (!isNaN(Date.parse(value))) return 'date'
      if (!isNaN(parseFloat(value)) && isFinite(value)) return 'number'
      return typeof value
    }

    const type = match.type || getType(aValue)

    switch (type) {
      case 'date':
        return (new Date(aValue).getTime() - new Date(bValue).getTime()) * this.sort[sortBy]
      case 'number':
        return (parseFloat(aValue) - parseFloat(bValue)) * direction
      case 'string':
        return aValue.localeCompare(bValue) * direction
      default:
        return 0
    }
  })
}

const SortLocal = function (target) {
  return function () {
    const items = path(target.split('.'), this) || []
    let [key] = Object.keys(this.sort)
    let match = this.sortableBy.find(e => e.key === key)
    if (match && !match.virtual) return items

    if (typeof match.type === 'function') return match.type({ items, key })

    return Sort.call(this, items, key, this.sort[key], match)
  }
}

const getSort = function () {
  let [key] = Object.keys(this.sort)
  let match = this.sortableBy.find(e => e.key === key)
  if (match && match.virtual) return {}

  return this.sort
}

export { SortWatcher, SortLocal, getSort, Sort }

export default {
  props: {
    value: Object,
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sortKey() {
      return Object.keys(this.value || {})[0]
    },
    sortLabel() {
      if (!this.sortKey) return

      return this.items.find(item => item.key === this.sortKey).label
    },
  },
  methods: {
    updateSort(item, value) {
      this.$emit('input', { [item.key]: value })
    },
  },
  components: {
    CheckboxComponent,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.sort {
  display: flex;
  align-items: end;

  &__label {
    display: flex;
    align-items: center;
    gap: 1em;
    span {
      opacity: 0.7;
      &:last-child {
        opacity: 1;
      }
    }
  }
  &__item-label {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
  }
  .elder-dropdown__content-box {
    max-height: 300px;
    overflow-y: auto;
    .elder-button {
      border: none !important;
      display: flex;
      justify-content: initial;
    }
  }
}
</style>
